let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4ZC4l")).then(() => parcelRequire('4faK1'));